import { Component } from '@angular/core';
import {  NavController, NavParams, ToastController, AlertController, ModalController  } from 'ionic-angular';
import { Globals } from '../../providers/globals';
import { BusinessProductInvoiceHandler } from '../../providers/business-product-invoice-handler';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { BusinessProductPaymentVoidManagerPage } from '../../pages/business-product-payment-void-manager/business-product-payment-void-manager';

@Component({
  selector: 'page-business-product-payment-invoice-detail',
  templateUrl: 'business-product-payment-invoice-detail.html',
})
export class BusinessProductPaymentInvoiceDetailPage {
	isLoading: boolean = false;
	isRedeeming: boolean = false;
	isRedeemed: boolean = false;
	invoice: any;
	invoiceDetail: any;
  filePath: any;
  og:any;

	constructor(
		public businessInvoiceHandler: BusinessProductInvoiceHandler, 
		public businessProductPaymentManagerHandler: BusinessProductPaymentManagerHandler,
		public alertCtrl: AlertController,
		public toastCtrl: ToastController,
    public modalCtrl: ModalController,
		public navCtrl: NavController,
		public globals: Globals, 
		public navParams: NavParams) {

		this.invoice = navParams.data["invoice"];
    this.filePath = this.globals.fileUrl;

		this.loadDetail();
	}

	loadDetail(){
		this.businessInvoiceHandler.getBusinessInvoiceDetail({id: this.invoice.Id})
		.then((data)=>{
			this.invoice = data;

      // this.invoice.RedeemedDate = data.RedeemedDate;

      if(this.invoice.GroupJSON){
        this.og = JSON.parse(this.invoice.GroupJSON)[0].products;  
      }  
		})
		.catch((err)=>{
			this.isLoading = false;	

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();	
		});		
	}

	confirmRedeem(){
    let alert = this.alertCtrl.create({
      title: 'Redeem invoice?',
      message: 'Are you sure you want to redeem this invoice?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            
          }
        },
        {
          text: 'Confirm',
          handler: () => {  
            this.redeem();
          }
        }
      ]
    });

    alert.present();
  }    

	redeem(){
    if(this.isRedeeming) return;

    this.isRedeeming = true;

    this.businessProductPaymentManagerHandler.redeem({
      invoiceId: this.invoice.Id,
      cb:(result)=>{
        if(result.Success){
          let alert = this.alertCtrl.create({
            title: 'Success',
            subTitle: 'Order has been redeemed!',
            buttons: ['Ok']
          });

          alert.present();

          this.loadDetail();

          this.isRedeemed = true

          this.isRedeeming = false;
        } else { 
          
          let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: result.Message,
              buttons: ['Ok']
            });
            
            alert.present();

            this.isRedeeming = false; 
        }
      }
    })

  }

  presentVoidModal(invoice) {

     let voidModal = this.modalCtrl.create(BusinessProductPaymentVoidManagerPage, {
       invoice: invoice
     });

     voidModal.onDidDismiss(voided => {
       if(voided) {
         this.loadDetail()

         let alert = this.alertCtrl.create({
            title: 'Success',
            subTitle: 'Order has been voided!',
            buttons: ['Ok']
          });

          alert.present();
       }
     });

     voidModal.present();
   }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-invoice-detail/business-product-payment-invoice-detail.ts